/**
 * We take the approach of organizing each “cast member” in a scene within its own file.
 * This is a choice and isn’t required, but it does isolate internal changes/enhancements
 * to these specific “characters.”
 */
import { FontLoader, TextGeometry, MeshNormalMaterial, Mesh } from 'three'

/**
 * The use of a JavaScript “class” is also a design choice.
 */
class Restart {
  constructor(UI, score) {
    let loader = new FontLoader()
    loader.load('https://threejs.org/examples/fonts/helvetiker_regular.typeface.json', function (font) {
      let geometry = new TextGeometry(`Game Over! You scored: ${score}. Press any key to play again.`, {
        font: font,
        size: 0.05,
        height: 0.01,
        curveSegments: 4,
        bevelEnabled: false
      })
      geometry.center()
      let material = new MeshNormalMaterial()
      let restartText = new Mesh(geometry, material)
      UI.restart = restartText
      UI.add(UI.restart)
      restartText.position.set(0, 0, -1)
    })
  }
}

export default Restart
